// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1oMWS","header":"PatientBlock_header__2RpfE","label":"PatientBlock_label__XnMjc","option":"PatientBlock_option__30AyN"};